module.exports = __webpack_public_path__ + "img/EN- 注册1.6b157819.png";